import { fork } from "redux-saga/effects";
import events from "./events";
import clients from "./clients";
import user from "./user";
import buyerIdentity from "./buyer-identity";
import purchase from "./purchase";

// eslint-disable-next-line func-names
export default function* () {
  yield fork(events);
  yield fork(clients);
  yield fork(user);
  yield fork(buyerIdentity);
  yield fork(purchase);
}
